module.exports = __webpack_public_path__ + "img/hr-green-carpet-grass-08.2d4bf060.png";